/* eslint-disable react/button-has-type */
import cn from 'classnames';
import { ComponentPropsWithoutRef, CSSProperties, forwardRef } from 'react';

import SpinnerIcon from '../SVGIcons/SpinnerIcon';
import classes from './CustomModal.module.scss';

type TButtonProps = ComponentPropsWithoutRef<'button'> & {
  outlined?: boolean;
  isLoading?: boolean;
  contentClassName?: string;
  contentStyle?: CSSProperties;
  contentProps?: ComponentPropsWithoutRef<'div'>;
};

export const Button = forwardRef<HTMLButtonElement, TButtonProps>(
  (
    {
      outlined,
      className,
      isLoading,
      children,
      contentProps,
      contentClassName,
      contentStyle,
      ...props
    },
    ref,
  ) => (
    <button
      {...props}
      ref={ref}
      className={cn(
        classes.button,
        {
          [classes['button--loading']]: isLoading,
          [classes['button--outlined']]: outlined,
        },
        className,
      )}
    >
      <SpinnerIcon className={classes.button__spinner} />
      <div
        {...contentProps}
        style={{ ...contentProps?.style, ...contentStyle }}
        className={cn(
          classes.button__content,
          contentProps?.className,
          contentClassName,
        )}
      >
        {children}
      </div>
    </button>
  ),
);
